import { render, staticRenderFns } from "./input-textarea.vue?vue&type=template&id=34b0d504&scoped=true"
import script from "./input-textarea.vue?vue&type=script&lang=ts"
export * from "./input-textarea.vue?vue&type=script&lang=ts"
import style0 from "./input-textarea.vue?vue&type=style&index=0&id=34b0d504&prod&lang=less&scoped=true"
import style1 from "./input-textarea.vue?vue&type=style&index=1&id=34b0d504&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b0d504",
  null
  
)

export default component.exports